import styled from "@emotion/styled";

export const StyledInput = styled.input`
  font-size: 1rem;
  font-family: Poppins Regular;
  border: solid #a2a2a2 1px;
  border-radius: 0.5em;
  padding: 0.5em;
  text-align: center;
  box-sizing: border-box;
`;
